module.exports = __webpack_public_path__ + "images/emoji/left_right_arrow.70969de2a9da6ee88f34.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/left_right_arrow.png
// module id = 6cdP
// module chunks = 1